
import { defineComponent, ref } from "vue";
import { bananoUtil } from "@/util/banano";
import { useRouter } from "vue-router";
import { storeUtil } from "@/store";
import CopyButton from "@/components/UI/CopyButton.vue";

export default defineComponent({
  name: "NewSeed",
  props: {
    importSeed: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    CopyButton,
  },

  setup(props) {
    const seed = ref("");
    if (!props.importSeed) seed.value = bananoUtil.generateRandomSeed();
    const seedDisclaimer = ref(false);

    const viewPage = ref("seed");
    const invalidSeed = ref(false);
    const setSeed = () => {
      if (bananoUtil.isSeedValid(seed.value)) {
        invalidSeed.value = false;
        viewPage.value = "password";
      } else invalidSeed.value = true;
    };

    const router = useRouter();
    const goBack = () => router.push({ name: "Home" });
    const backToSeed = () => (viewPage.value = "seed");

    const password = ref("");
    const passwordCopy = ref("");
    const setPassword = () => {
      storeUtil.mutations.saveSeed(seed.value, password.value);
      router.push({ name: "Dashboard" });
    };

    return {
      seed,
      seedDisclaimer,
      viewPage,
      password,
      passwordCopy,
      goBack,
      backToSeed,
      setSeed,
      setPassword,
      invalidSeed,
    };
  },
});
